import { MutableRefObject } from 'react'
import { IsVarEmpty } from '../../../NonReact/utils/GlobalFunctions'

/**
 * Increment a counter value by 1.
 */
export const incrementCounterRef = (counterValue: MutableRefObject<number>): void => {
    counterValue.current += 1
}

export const isNumberPositive = (value: number): boolean => Math.sign(value) === 1

export const calculateDifference = (num1: number, num2: number): number => {
    if (IsVarEmpty(num1) || IsVarEmpty(num2) || Number.isNaN(num1) || Number.isNaN(num2)) return 0

    return num2 - num1
}
